// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"InputSearch_searchIcon__brVLt"};